import React, { useEffect, useState } from 'react';
import StAddNew from './DSeries/StAddNew';
import { Button, Col, Form, Modal, Row, Tooltip, message, Input, notification } from 'antd';
import { useSelector } from 'react-redux';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
const { TextArea } = Input;

const ZenJSONEditor = ({
    setPageHeader
}) => {
    const urlCode = useSelector(state => state.urlCode);

    const [dictForm] = Form.useForm();
    const [dictFormVal, setDictFormVal] = useState();
    const [form] = Form.useForm();
    const [pageConfigData, setPageConfigData] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setPageHeader('Zen JSON Editor')
    }, []);


    const downloadJson = () => {
        liracrypt.get('/pageconfig/download', { ...dictForm.getFieldsValue() }).then(({ data }) => {
            if (data.isSuccess) {
                window.open(
                    `${process.env.REACT_APP_API_ENDPOINT}/fetchfilesingleattachmentzenform?filePath=${data.data.filePath}&fileName=${data.data.fileName}&token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
                    '_blank'
                )
            } else {
                message.error(data.message);
            }
        })
    }

    const updateJSON = (value) => {
        try {
            setLoading(true);
            JSON.parse(value.jsonData);
            liracrypt.post('/config/jsoneditor', { json: JSON.parse(value.jsonData), queryElements: dictFormVal })
                .then(response => {
                    setLoading(false);
                    notification.success({
                        message: response?.data?.message
                            ? response?.data?.message
                            : "JSON saved successfully",
                    });
                }).catch(err => {
                    console.log(err);
                    setLoading(false);
                    ApiErrorComp(err);
                })
        } catch (e) {
            setLoading(false);
            message.error(e.message);
        }
    }


    return (
        <div>
            <div className='phantom-form'>
                <StAddNew
                    initForm={dictForm}
                    colSpan={12}
                    stopResetForm={true}
                    urlEndpoint="/miscellaneous/pageconfig"
                    urlData={{ dictName: "ConfigJsonEditorQuery" }}
                    extraData={{}}
                    onCallFinish={({ data }) => {
                        setDictFormVal(dictForm.getFieldsValue());
                        setPageConfigData(data.data);
                        form.setFieldValue('jsonData', JSON.stringify(data.data, null, 4));
                    }}
                />
            </div>
            {
                pageConfigData && (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: 20, paddingRight: 30 }}>
                            <Button ghost={true} style={{ marginRight: 20 }} type="primary" onClick={downloadJson}>
                                Download JSON
                            </Button>
                            <Button
                                type="primary"
                                ghost={true}
                                onClick={() => {
                                    navigator.clipboard.writeText(JSON.stringify(pageConfigData, null, 2)).then(() => {
                                        message.success('Copied Successfully');
                                    })
                                }}>Click To Copy</Button>
                            {/* <Button ghost={true} style={{ marginRight: 20 }} type="primary" onClick={() => openSmodal({ typ: 'upload-json' })}>
                                Upload JSON
                            </Button>
                            <Button ghost={true} style={{ marginRight: 20 }} type="primary" onClick={() => openSmodal({ typ: 'upload-json' })}>
                                Upload JSON Data
                            </Button> */}
                        </div>

                        <>
                            <div className={`AuditSection CreateAudit`} style={{ padding: "10px" }}>
                                <div className={`ThemeForm phantom-form`}>
                                    <Form

                                        name={`jsonForm`}
                                        form={form}
                                        labelWrap={true}
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 24 }}
                                        layout="horizontal"
                                        colon={false}
                                        onFinish={updateJSON}
                                        size="large"
                                    >
                                        <Row justify={"center"}>
                                            <Col span={24}>
                                                <Form.Item name="jsonData">
                                                    <TextArea spellCheck={false} size='large' rows={15} placeholder='JSON DATA' />
                                                </Form.Item>
                                                {/* <p style={{ color: 'white', minHeight: 500, border: '1px solid white', width: '100%' }}><pre onInput={(e) => console.log(e.target.innerText) } contentEditable>{JSON.stringify(pageConfigData, null, 2)}</pre></p> */}
                                            </Col>
                                        </Row>

                                        <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                            <Button loading={loading} htmlType='submit' type="primary">Submit</Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </>
                    </>
                )
            }

        </div>
    )
}

export default ZenJSONEditor;